import { render, staticRenderFns } from "./zxreply.vue?vue&type=template&id=705eb8c5&scoped=true&"
import script from "./zxreply.vue?vue&type=script&lang=js&"
export * from "./zxreply.vue?vue&type=script&lang=js&"
import style0 from "./zxreply.vue?vue&type=style&index=0&id=705eb8c5&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705eb8c5",
  null
  
)

export default component.exports